import type { AnalyticsSubscriber, DeepPartial, SdkConfiguration } from '../types';
import { AnalyticsEvent, LicenseInfo, OcrConfigsResult, withSBErrorHandling } from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotSdkImpl = {
  async initialize(config: SdkConfiguration): Promise<LicenseInfo> {
    return withSBErrorHandling(async () => new LicenseInfo(await ScanbotSDKPlugin.initialize(config)));
  },

  async getLicenseInfo(): Promise<LicenseInfo> {
    return withSBErrorHandling(async () => new LicenseInfo(await ScanbotSDKPlugin.getLicenseInfo()));
  },

  async getOcrConfigs(): Promise<OcrConfigsResult> {
    return withSBErrorHandling(async () => new OcrConfigsResult(await ScanbotSDKPlugin.getOcrConfigs()));
  },

  async cleanupStorage(): Promise<void> {
    return withSBErrorHandling(ScanbotSDKPlugin.cleanupStorage);
  },

  async setAnalyticsSubscriber(subscriber: AnalyticsSubscriber | null): Promise<void> {
    if (subscriber) {
      return ScanbotSDKPlugin.setAnalyticsServiceCallback({}, (event: DeepPartial<AnalyticsEvent>) => {
        if (event) {
          subscriber(new AnalyticsEvent(event));
        }
      });
    } else {
      return ScanbotSDKPlugin.removeAnalyticsServiceCallback();
    }
  },

  async mockCamera(params: {
    imageFileUri: string;
    captureFileUri?: string;
    refreshOnEachFrame?: boolean;
  }): Promise<void> {
    return withSBErrorHandling(() => ScanbotSDKPlugin.mockCamera(params));
  },
};
